// ============================================================================
// KOREAN TRANSLATIONS - CHAPTER 7: 서신과 요한계시록
// ============================================================================
// 레벨 79-91 (13 레벨, 39 문제)

export const chapter7Translations = {
  name: "서신과 요한계시록",
  description: "이기는 자는 이 모든 것을 상속받으리라... 위로부터 오는 지혜는 이해를 거룩하게 한다",
  
  spiritualWisdom: {
    principle: "위로부터 오는 지혜는 이해를 거룩하게 하고 영을 살린다",
    scripture: "너희 중에 누구든지 지혜가 부족하거든 하나님께 구하라(야고보서 1:5)",
    application: "모든 사도 서신과 계시록의 모든 환상은 우리의 이해를 풍요롭게 하고 희망을 강화합니다"
  },
  
  levels: {
    79: {
      name: "예루살렘에서의 체포",
      challenge: "나는 결박당할 뿐 아니라 예루살렘에서 죽을 각오도 되어 있습니다...",
      easy: {
        question: "바울이 마지막 방문에서 어디에서 체포되었습니까?",
        options: ["안디옥", "에베소", "예루살렘", "고린도"],
        correctAnswer: 2,
        hint: "자주 선지자들을 박해했던 거룩한 도시",
        funFact: "🏛️ 예루살렘: 하나님의 모든 종들에게 영광과 고난의 장소!"
      },
      medium: {
        question: "유대인들은 바울을 무엇으로 고소했습니까?",
        options: [
          "성전에서의 도둑질",
          "이방인을 성전에 데려와 성전을 모독함",
          "모세에 대한 신성모독",
          "로마에 대한 반역"
        ],
        correctAnswer: 1,
        hint: "복음의 보편성과 관련된 고소",
        funFact: "⛪ 아이러니: 바울은 깊이 존경했던 성전을 모독했다고 고소당했다!"
      },
      hard: {
        question: "바울은 투옥을 어떻게 기회로 바꾸었습니까?",
        options: [
          "도망쳤다",
          "당국 앞에서 증언하고 서신을 썼다",
          "침묵했다",
          "석방을 협상했다"
        ],
        correctAnswer: 1,
        hint: "시련을 증언으로 바꾸는 것에 관한 것",
        funFact: "⛓️ 육체의 사슬, 영적 자유 - 강력한 믿음의 증언!"
      }
    },
    
    80: {
      name: "총독 벨릭스 앞에서",
      challenge: "의와 절제와 장차 올 심판에 대해 논할 때...",
      easy: {
        question: "바울이 어느 총독 앞에서 믿음을 증언했습니까?",
        options: ["빌라도", "벨릭스", "베스도", "갈리오"],
        correctAnswer: 1,
        hint: "탐욕으로 알려진 총독",
        funFact: "⚖️ 벨릭스는 뇌물을 기대했다 - 성실 앞의 부패!"
      },
      medium: {
        question: "바울의 메시지에 대한 벨릭스의 반응은?",
        options: [
          "개종했다",
          "두려워 떨었다",
          "비웃었다",
          "무관심했다"
        ],
        correctAnswer: 1,
        hint: "진리에 동요된 양심",
        funFact: "😰 부패한 자들도 하나님의 진리 앞에서 떤다 - 보편적 양심!"
      },
      hard: {
        question: "벨릭스가 바울을 2년 동안 투옥한 이유는?",
        options: [
          "바울을 보호하기 위해",
          "정치적 이익과 부패의 기대",
          "잊어버려서",
          "확신 때문에"
        ],
        correctAnswer: 1,
        hint: "정치적이고 개인적인 계산에 관한 것",
        funFact: "🏛️ 부패한 인간의 정의 vs 완벽한 하나님의 정의 - 날카로운 대조!"
      }
    },

    81: {
      name: "가이사에게 상소함",
      challenge: "내가 가이사에게 상소하노라!",
      easy: {
        question: "바울이 예루살렘에서의 재판을 피하기 위해 무엇을 주장했습니까?",
        options: [
          "망명권",
          "가이사에게 상소(로마 시민)",
          "도주권",
          "외교적 보호"
        ],
        correctAnswer: 1,
        hint: "로마 시민권의 특권",
        funFact: "🏛️ 로마 시민권: 복음을 로마로 가져가는 하나님의 여권!"
      },
      medium: {
        question: "출발 전 바울은 누구 앞에서 증언했습니까?",
        options: [
          "산헤드린",
          "아그립바 왕과 버니게",
          "로마 군인들",
          "유대 군중"
        ],
        correctAnswer: 1,
        hint: "유대화된 헤롯 왕족",
        funFact: "👑 양치기에서 왕궁으로 - 바울의 하나님의 승격!"
      },
      hard: {
        question: "하나님은 인간의 시스템을 계획에 어떻게 사용하십니까?",
        options: [
          "무시한다",
          "섭리적으로 사용하여 계획을 실현한다",
          "파괴한다",
          "항상 반대한다"
        ],
        correctAnswer: 1,
        hint: "역사에 대한 하나님의 주권에 관한 것",
        funFact: "🌐 로마의 정의가 복음의 매개체가 된다 - 놀라운 섭리!"
      }
    },

    82: {
      name: "몰타에서의 난파",
      challenge: "두려워하지 말라 바울아. 네가 가이사 앞에 서야 하리라...",
      easy: {
        question: "바울이 어느 섬에서 난파했습니까?",
        options: ["그레데", "구브로", "몰타", "시칠리아"],
        correctAnswer: 2,
        hint: "시칠리아 남쪽의 작은 섬",
        funFact: "🏝️ 몰타: 강제 정지가 열매 맺는 선교가 된다 - 하나님의 우회!"
      },
      medium: {
        question: "바울이 몰타에서 어떤 기적을 행했습니까?",
        options: [
          "폭풍을 잔잔하게 했다",
          "보블리오의 아버지와 다른 병자들을 치유했다",
          "음식을 늘렸다",
          "죽은 자를 살렸다"
        ],
        correctAnswer: 1,
        hint: "섬에서의 여러 치유",
        funFact: "🏥 바울: 난파자에서 기적의 의사로 - 하나님의 평판!"
      },
      hard: {
        question: "이 난파는 하나님의 신실하심을 어떻게 보여줍니까?",
        options: [
          "사고는 일어난다",
          "하나님은 장애물에도 불구하고 약속을 지키고 실현하신다",
          "바울이 운이 좋았다",
          "피할 수 있었다"
        ],
        correctAnswer: 1,
        hint: "약속에 대한 하나님의 신실하심에 관한 것",
        funFact: "⛈️ 폭풍, 난파, 뱀: 바울에 대한 하나님의 계획을 막을 수 없다!"
      }
    },

    83: {
      name: "로마의 바울",
      challenge: "온 이년을 자기 셋집에 머물면서...",
      easy: {
        question: "바울은 로마에서 어떤 상황에서 살았습니까?",
        options: [
          "폐쇄된 감옥에서",
          "가택 연금",
          "완전한 자유",
          "추방"
        ],
        correctAnswer: 1,
        hint: "감시 하의 상대적 자유",
        funFact: "🏠 집-감옥이 선교 센터가 된다 - 사슬 속의 자유!"
      },
      medium: {
        question: "바울은 로마에서 2년 동안 무엇을 했습니까?",
        options: [
          "쉬었다",
          "가르치고 서신을 썼다",
          "변호를 준비했다",
          "관광했다"
        ],
        correctAnswer: 1,
        hint: "사슬에도 불구하고 강렬한 사역",
        funFact: "✍️ 옥중 서신: 에베소서, 빌립보서, 골로새서, 빌레몬서!"
      },
      hard: {
        question: "전통에 따르면 바울은 어떻게 사역을 마쳤습니까?",
        options: [
          "병으로 죽었다",
          "67년경 네로 치하에서 참수당했다",
          "노환으로 죽었다",
          "신비롭게 사라졌다"
        ],
        correctAnswer: 1,
        hint: "광기의 황제 치하에서의 순교",
        funFact: "⚔️ '선한 싸움을 싸우고 달려갈 길을 마쳤다' - 최종 승리!"
      }
    },

    84: {
      name: "로마서",
      challenge: "내가 복음을 부끄러워하지 아니하노니 이 복음은 믿는 모든 자에게 구원을 주시는 하나님의 능력...",
      easy: {
        question: "어느 서신이 믿음으로 구원받는 교리를 가장 많이 전개합니까?",
        options: ["고린도전서", "갈라디아서", "로마서", "에베소서"],
        correctAnswer: 2,
        hint: "바울의 신학적 '대성당'",
        funFact: "🏛️ 로마서: 어거스틴과 루터를 개종시킨 신학적 걸작!"
      },
      medium: {
        question: "로마서에 따르면 사람이 하나님 앞에서 어떻게 의롭다 함을 받습니까?",
        options: [
          "선행으로",
          "믿음으로만, 행위 없이",
          "제사로",
          "전통으로"
        ],
        correctAnswer: 1,
        hint: "종교개혁의 기본 원리",
        funFact: "⚖️ '의인은 믿음으로 살리라' - 바울의 영적 혁명!"
      },
      hard: {
        question: "이 서신의 보편적 범위는 무엇입니까?",
        options: [
          "로마인들에게만 관련됨",
          "전 인류를 위한 구원 계획을 설명함",
          "로마만 비판함",
          "시대에 뒤떨어짐"
        ],
        correctAnswer: 1,
        hint: "보편적 구원 계획에 관한 것",
        funFact: "🌍 복음=모든 사람을 위한 하나님의 능력: 유대인과 헬라인 - 완전한 보편성!"
      }
    },

    85: {
      name: "사랑의 찬가 - 고린도전서 13장",
      challenge: "내가 사람의 방언과 천사의 말을 할지라도 사랑이 없으면...",
      easy: {
        question: "성경의 어느 장이 '사랑의 찬가'라고 불립니까?",
        options: [
          "고린도전서 12장",
          "고린도전서 13장",
          "요한일서 4장",
          "로마서 8장"
        ],
        correctAnswer: 1,
        hint: "고린도전서의 중심 장",
        funFact: "💝 결혼식에서 가장 많이 읽히는 장 - 사랑의 완벽한 정의!"
      },
      medium: {
        question: "바울은 사랑의 지속성에 대해 무엇이라고 말합니까?",
        options: [
          "사랑은 시간과 함께 지나간다",
          "사랑은 언제까지나 떨어지지 아니한다",
          "사랑은 상황에 따른다",
          "사랑은 일시적이다"
        ],
        correctAnswer: 1,
        hint: "하나님의 사랑의 영원성",
        funFact: "♾️ 사랑만이 죽음과 영원을 넘어선다 - 최고의 가치!"
      },
      hard: {
        question: "바울이 사랑을 영적 은사 위에 두는 이유는?",
        options: [
          "은사는 나쁘다",
          "사랑이 모든 것에 의미와 가치를 준다",
          "사랑이 더 쉽다",
          "은사는 분열시킨다"
        ],
        correctAnswer: 1,
        hint: "모든 섬김의 원동력과 의미에 관한 것",
        funFact: "🎯 사랑 없이는 가장 큰 은사도 소음과 교만이 된다!"
      }
    },

    86: {
      name: "에베소서: 그리스도의 몸인 교회",
      challenge: "만물을 그의 발 아래 복종하게 하시고 그를 만물 위에 교회의 머리로 삼으셨느니라...",
      easy: {
        question: "에베소서에 따르면 교회는 그리스도와의 관계에서 무엇입니까?",
        options: [
          "그의 성전",
          "그의 몸",
          "그의 가족",
          "그의 군대"
        ],
        correctAnswer: 1,
        hint: "일치의 유기적 비유",
        funFact: "👤 그리스도의 몸: 모든 그리스도인은 필수적인 지체 - 상호의존!"
      },
      medium: {
        question: "바울은 영적 전쟁을 위해 어떤 갑옷을 묘사합니까?",
        options: [
          "물리적 갑옷",
          "하나님의 전신갑주: 진리, 의, 평화, 믿음, 구원, 말씀",
          "로마의 갑옷",
          "마법의 보호"
        ],
        correctAnswer: 1,
        hint: "6가지 영적 갑옷",
        funFact: "⚔️ 영적 전투에는 영적 무기 - 승리의 하나님의 전략!"
      },
      hard: {
        question: "바울에 따르면 우리의 진정한 싸움은 무엇을 대적하는 것입니까?",
        options: [
          "악한 사람들을 대적함",
          "악의 영적 세력을 대적함",
          "정부를 대적함",
          "빈곤을 대적함"
        ],
        correctAnswer: 1,
        hint: "보이지 않는 영적 힘에 관한 것",
        funFact: "👹 우주적 전투: 인간 갈등 뒤에 실제 영적 전쟁이 있다!"
      }
    },

    87: {
      name: "빌립보서: 시련 중의 기쁨",
      challenge: "주 안에서 항상 기뻐하라 내가 다시 말하노니 기뻐하라!",
      easy: {
        question: "바울이 투옥되었음에도 불구하고 어떤 감정을 권장합니까?",
        options: ["체념", "기쁨", "분노", "슬픔"],
        correctAnswer: 1,
        hint: "죄수에게 놀라운 감정",
        funFact: "😊 4장에서 16번의 기쁨 - 감옥에서의 행복 기록!"
      },
      medium: {
        question: "빌립보서 2장에 따르면 예수님은 어떤 태도를 취하셨습니까?",
        options: [
          "힘으로 강요했다",
          "자신을 낮추고 죽기까지 겸손했다",
          "책임에서 도망했다",
          "영광을 구했다"
        ],
        correctAnswer: 1,
        hint: "자발적인 하강 운동",
        funFact: "📉 예수님: 하나님과 동등하심에서 십자가의 죽음까지 - 극도의 사랑!"
      },
      hard: {
        question: "바울이 어떻게 감옥에서 기쁨을 설교할 수 있습니까?",
        options: [
          "가짜다",
          "그리스도인의 기쁨은 상황을 초월한다",
          "마조히스트다",
          "현실을 부정한다"
        ],
        correctAnswer: 1,
        hint: "초자연적인 기쁨에 관한 것",
        funFact: "✨ 기쁨=상황과 무관한 성령의 열매 - 하나님의 비밀!"
      }
    },

    88: {
      name: "목회 서신",
      challenge: "믿음의 선한 싸움을 싸우고 영생을 취하라...",
      easy: {
        question: "바울이 마지막 목회 서신을 누구에게 썼습니까?",
        options: [
          "고린도인들에게",
          "디모데와 디도에게",
          "로마인들에게",
          "갈라디아인들에게"
        ],
        correctAnswer: 1,
        hint: "그의 영적 자녀들과 협력자들",
        funFact: "👨‍👦 영적 유언: 바울이 다음 세대에 횃불을 넘겨준다!"
      },
      medium: {
        question: "바울이 교회 지도자를 선택하기 위해 어떤 조언을 합니까?",
        options: [
          "가장 부유한 사람을 선택",
          "엄격한 도덕적·영적 기준에 따라 선택",
          "가장 교육받은 사람을 선택",
          "가장 인기 있는 사람을 선택"
        ],
        correctAnswer: 1,
        hint: "무엇보다 도덕적 자격",
        funFact: "⚖️ 지도자의 높은 기준: 능력보다 품성 - 하나님의 우선순위!"
      },
      hard: {
        question: "바울이 디모데에게 어떤 유산을 남깁니까?",
        options: [
          "물질적 재산",
          "복음에 대한 충실함과 목회 사역",
          "정치적 직위",
          "신학교"
        ],
        correctAnswer: 1,
        hint: "영적 유산에 관한 것",
        funFact: "📜 '선한 것을 지키라' - 세기를 통한 복음의 충실한 전달!"
      }
    },

    89: {
      name: "히브리서: 예수 대제사장",
      challenge: "하늘들을 통과하신 위대한 대제사장이 계시니...",
      easy: {
        question: "히브리서에 따르면 우리의 위대한 대제사장은 누구입니까?",
        options: ["아론", "모세", "예수", "멜기세덱"],
        correctAnswer: 2,
        hint: "하나님과 사람 사이의 완벽한 중보자",
        funFact: "✝️ 예수님: 제사장이자 희생 - 한 번으로 완벽한 희생!"
      },
      medium: {
        question: "예수님의 제사장 직분이 아론의 것보다 우월한 이유는?",
        options: [
          "더 오래되어서",
          "멜기세덱의 반차를 따라 영원해서",
          "더 부유해서",
          "더 인기 있어서"
        ],
        correctAnswer: 1,
        hint: "영원성 vs 일시성",
        funFact: "♾️ 영원한 제사장 직분: 예수님은 우리를 위해 영원히 중보하신다!"
      },
      hard: {
        question: "히브리서는 새 언약을 어떻게 제시합니까?",
        options: [
          "옛 것과 동일함",
          "우월하고 최종적이며 마음에 기록됨",
          "일시적임",
          "선택적임"
        ],
        correctAnswer: 1,
        hint: "성취와 초월에 관한 것",
        funFact: "📋 새 언약: 돌판이 아닌 마음에 기록된 율법!"
      }
    },

    90: {
      name: "야고보서: 믿음과 행위",
      challenge: "행함이 없는 믿음은 죽은 것이라...",
      easy: {
        question: "야고보에 따르면 믿음에 무엇이 동반되어야 합니까?",
        options: [
          "말",
          "행위",
          "감정",
          "지식"
        ],
        correctAnswer: 1,
        hint: "믿음의 실천적 표현",
        funFact: "🌳 믿음=뿌리, 행위=열매 - 완전한 영적 나무!"
      },
      medium: {
        question: "야고보는 혀를 무엇에 비유합니까?",
        options: [
          "칼",
          "큰 숲을 태우는 작은 불",
          "악기",
          "도구"
        ],
        correctAnswer: 1,
        hint: "작은 지체지만 큰 파괴력",
        funFact: "🔥 혀: 작은 지체지만 전 생애를 불태울 수 있다 - 조심!"
      },
      hard: {
        question: "믿음/행위에 대해 야고보와 바울을 어떻게 조화시킵니까?",
        options: [
          "모순된다",
          "바울은 칭의에 대해, 야고보는 성화에 대해 말한다",
          "한쪽이 틀렸다",
          "해결책이 없다"
        ],
        correctAnswer: 1,
        hint: "두 가지 보완적 측면에 관한 것",
        funFact: "⚖️ 바울: 믿음으로 구원 / 야고보: 행위로 증명되는 믿음 - 완벽한 조화!"
      }
    },

    91: {
      name: "요한계시록: 왕의 귀환",
      challenge: "보라 내가 속히 오리니. 이 책의 예언의 말씀을 지키는 자가 복이 있도다!",
      easy: {
        question: "요한계시록에서 요한이 몇 교회에 편지를 썼습니까?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "완전성의 수",
        funFact: "⛪ 아시아의 7교회: 모든 시대의 모든 교회의 거울!"
      },
      medium: {
        question: "요한계시록에 따르면 역사는 어떻게 끝납니까?",
        options: [
          "완전한 파괴",
          "새 하늘과 새 땅",
          "지상 낙원으로 귀환",
          "모든 존재의 종말"
        ],
        correctAnswer: 1,
        hint: "창조의 완전한 갱신",
        funFact: "🌅 세상의 종말이 아니라 완전한 갱신 - 궁극적 희망!"
      },
      hard: {
        question: "요한계시록은 박해받는 자들에게 무엇을 전합니까?",
        options: [
          "항복하라",
          "그리스도께서 다스리시고 최종적으로 승리하신다",
          "박해에서 도망하라",
          "복수하라"
        ],
        correctAnswer: 1,
        hint: "최종 승리의 희망에 관한 것",
        funFact: "👑 '전에도 계셨고 지금도 계시고 장차 오실 이' - 역사와 시간의 주!"
      }
    }
  }
};

export default chapter7Translations;
